export default __webpack_public_path__ + "ce34bb0f58b6385d50b09fa310053eca.woff2";